export function MagicPen({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.91719 17.0826C3.60885 17.7742 4.72552 17.7742 5.41719 17.0826L16.2505 6.24922C16.9422 5.55755 16.9422 4.44089 16.2505 3.74922C15.5589 3.05755 14.4422 3.05755 13.7505 3.74922L2.91719 14.5826C2.22552 15.2742 2.22552 16.3909 2.91719 17.0826Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.0078 7.49219L12.5078 4.99219"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.08203 2.03464L8.33203 1.66797L7.96536 2.91797L8.33203 4.16797L7.08203 3.8013L5.83203 4.16797L6.1987 2.91797L5.83203 1.66797L7.08203 2.03464Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.75 7.03464L5 6.66797L4.63333 7.91797L5 9.16797L3.75 8.8013L2.5 9.16797L2.86667 7.91797L2.5 6.66797L3.75 7.03464Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.25 11.1987L17.5 10.832L17.1333 12.082L17.5 13.332L16.25 12.9654L15 13.332L15.3667 12.082L15 10.832L16.25 11.1987Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
